import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "16px",
	height: "18px",
	viewBox: "0 0 16 18",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Combined Shape" }), /* @__PURE__ */ _jsx("g", {
		id: "Stylesheet",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			transform: "translate(-405.000000, -167.000000)",
			fill: "#000000",
			fillRule: "nonzero",
			id: "Combined-Shape",
			children: /* @__PURE__ */ _jsx("path", { d: "M406,178.03541 L406,183.98141 L420,183.98141 L420,178.03541 L421,178.03541 L421,184.972708 L405,184.972708 L405,178.03541 L406,178.03541 Z M413.187808,166.967166 L418.093219,171.872577 L417.386112,172.579683 L413.679595,168.871752 L413.668885,181.08854 L412.673354,181.096686 L412.683989,168.880238 L408.964169,172.598685 L408.257062,171.891578 L413.162472,166.986167 L413.166235,166.989434 L413.187808,166.967166 Z" })
		})
	})]
});
export default SvgUpload;
